/* ===========================================
   RATING COMPONENT (Auto-generated stars)
   =========================================== */

$(document).ready(function () {

  // Loop through every .rating element
  $(".rating").each(function () {
    const rateWrap = $(this);

    // Get rating from data-rating attribute (0–5), default 5
    const value = Math.max(
      0,
      Math.min(5, parseInt(rateWrap.data("rating"), 10) || 5)
    );

    // If .rating has no child elements, auto-generate 5 stars
    if (rateWrap.children().length === 0) {
      for (let i = 0; i < 5; i++) {
        rateWrap.append(
          '<span class="star-icon icon" aria-hidden="true"></span>'
        );
      }
    }

    // Accessibility text: "5 out of 5"
    rateWrap.attr("aria-label", value + " out of 5 stars");

    // Remove active class, then add active to correct stars
    rateWrap
      .children(".star-icon")
      .removeClass("is-active")
      .slice(0, value)
      .addClass("is-active");
  });

});
/* ===========================================
   RATING COMPONENT – STAR ICON SYSTEM
   =========================================== */

// /* Wrapper */
// .rating {
//   display: inline-flex;
//   gap: 4px;
// }

// /* Default star */
// .star-icon {
//   width: 20px;
//   height: 20px;
//   color: #ccc; /* inactive color */
//   background-color: currentColor;
//   mask: url('../icons/star.svg') center/contain no-repeat;
//   -webkit-mask: url('../icons/star.svg') center/contain no-repeat;
//   transition: 0.3s;
// }

// /* Active (filled) star */
// .star-icon.is-active {
//   color: #f5b500; /* golden */
// }


// html 
{/* <div class="rating" data-rating="4"></div> */}